import { Injectable } from '@angular/core';
import { Action, State, type StateContext } from '@ngxs/store';
import { type UserGetDTO } from '@szebit-app/sdk/backend';
import { SetUserAction } from './action/set-user.action';
import { produce } from 'immer';

export interface UserStateModel {
  user: UserGetDTO | null | 'loading';
}

@State<UserStateModel>({
  name: 'user',
  defaults: {
    user: 'loading',
  },
})
@Injectable()
export class UserState {
  @Action(SetUserAction)
  setUser({ setState }: StateContext<UserStateModel>, { user }: SetUserAction): void {
    setState(
      produce(draft => {
        draft.user = user;
      }),
    );
  }
}
